import { API_ENDPOINT } from '../../../constants';

export const INTAKE_QUESTIONNAIRES_API_BASE = `${API_ENDPOINT}/intake_questionnaires`;
